import { Link } from "react-router-dom";
import { Home, Search } from "lucide-react";
import Seo from "@/components/Seo";

export default function NotFound() {
  return (
    <div className="mx-auto flex max-w-3xl flex-col items-center px-4 py-32 text-center sm:px-6">
      <Seo title="Halaman tidak ditemukan" />
      <p className="font-heading text-8xl font-800 text-berry">404</p>
      <h1 className="mt-4 font-heading text-3xl font-700 tracking-tight text-white">Halaman tidak ditemukan</h1>
      <p className="mt-3 text-gray-400">Maaf, halaman yang Anda cari tidak tersedia atau sudah dipindahkan.</p>
      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <Link to="/" className="inline-flex items-center gap-2 rounded-full bg-berry px-6 py-3 font-semibold text-white transition-colors hover:bg-berry-dark">
          <Home className="h-4 w-4" /> Ke Beranda
        </Link>
        <Link to="/katalog" className="inline-flex items-center gap-2 rounded-full border border-white/15 px-6 py-3 font-semibold text-white transition-colors hover:bg-white/5">
          <Search className="h-4 w-4" /> Lihat Katalog
        </Link>
      </div>
    </div>
  );
}
